import { useWhoAmIQuery } from '@frontend/core/lib/modules/authentication'
import { updateSentryUser } from '@frontend/core/lib/sentry'
import { useEffect } from 'react'
import { useAppSelector } from '../../store/hooks'

// Component to update Sentry user context based on enrollment status or user data //
// If the app is running on the pitch side, use enrollment status //
// Otherwise, use authenticated user data //
export function SentryUser() {
  const { pitchSide } = useAppSelector((state) => state.app.config)

  const { laptop } = useAppSelector(
    (state) => state.metricsServer.metricsServerState.authState
  )

  const { data: user } = useWhoAmIQuery(undefined, {
    skip: pitchSide
  })

  useEffect(() => {
    if (pitchSide && laptop) {
      updateSentryUser(laptop)
    } else if (!pitchSide && user) {
      updateSentryUser(user)
    } else {
      updateSentryUser(null)
    }
  }, [laptop, user, pitchSide])

  return null
}
